export default "__VITE_ASSET__BUXE0oz7__"